module.exports = __webpack_public_path__ + "img/美妆特效--自定义妆容.839dec01.png";